import React, { useState } from 'react'
import { ColumnsType } from 'antd/lib/table'
import { useRequest } from 'ahooks'
import $msg from '@/utils/message'
import { getMemberChainCoinRecords } from '../../api'
import {
    CHAIN_COIN_CHANGE_TYPE_LIST,
    CHAIN_COIN_CHANGE_TYPE_MAP,
    formatAmount,
    formatDateTime,
    getOperatorName,
    getShopName,
    RECORD_PAGE_SIZE,
} from './record-utils'
import MemberRecordTable from './record-table'

interface Props {
    memberId: number
}

const ChainCoinRecord: React.FC<Props> = props => {
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(RECORD_PAGE_SIZE)
    const req = useRequest(
        () =>
            getMemberChainCoinRecords({
                member_id: props.memberId,
                page,
                limit: pageSize,
                change_type: CHAIN_COIN_CHANGE_TYPE_LIST,
            }),
        {
            refreshDeps: [props.memberId, page, pageSize],
            onError: e => $msg('error', e.message || '获取连锁币变动失败'),
        },
    )
    const columns: ColumnsType<any> = [
        { title: '时间', dataIndex: 'create_time', width: 170, render: formatDateTime },
        {
            title: '变动类型',
            dataIndex: 'change_type',
            width: 140,
            render: value => CHAIN_COIN_CHANGE_TYPE_MAP[value] || '-',
        },
        { title: '店铺', dataIndex: 'shop', width: 160, render: getShopName },
        { title: '订单号', dataIndex: 'order_no', width: 220, render: value => value || '-' },
        { title: '变动连锁币', dataIndex: 'change_chain_coin', width: 120, render: formatAmount },
        { title: '变动后连锁币', dataIndex: 'remain_chain_coin', width: 128, render: formatAmount },
        { title: '操作员', dataIndex: 'creator', width: 112, render: getOperatorName },
    ]

    return (
        <MemberRecordTable
            rowKey={(record, index) => record.id || index}
            loading={req.loading}
            columns={columns}
            dataSource={req.data?.chain_coin_change_record_list || []}
            page={page}
            pageSize={pageSize}
            pagination={req.data?.pagination}
            onPageChange={setPage}
            onPageSizeChange={(nextPage, nextSize) => {
                setPage(nextPage)
                setPageSize(nextSize)
            }}
        />
    )
}

export default ChainCoinRecord
